import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.5rem 0.75rem;
  width: 100%;
  max-width: none;

  @media (max-width: 768px) {
    padding: 0.5rem 0.5rem;
  }
`

export const Header = styled.div`
  margin-bottom: 1rem;
  text-align: center;

  @media (max-width: 768px) {
    margin-bottom: 0.75rem;
  }
`

export const CardGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;

  @media (max-width: 768px) {
    gap: 0.5rem;
  }
`
